import { Canvas } from "@craftjs/core";
import { SplitIcon } from "lucide-react";

import { define } from "@/components/builder/utils";

import { ConditionBlock, ConditionCaseBlock } from "..";
import BasePreview from "../base";

function ConditionPreview() {
  return <BasePreview>
    <div>
      <Canvas
        is={ConditionBlock}
        id="optout">
        <Canvas is={ConditionCaseBlock} custom={{ name: 'Case true' }}></Canvas>
        <Canvas is={ConditionCaseBlock} custom={{ name: 'Case false' }}></Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

export default define('custom-condition', ConditionPreview)
  .canvas()
  .palete(<SplitIcon size={16} />, 'Condition', 'Advanced')
  .build()
